export const LEGAL_NAME = /^[a-zA-Z '-]*$/;

export const VALID_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default {
  LEGAL_NAME,
  VALID_EMAIL,
};
